const SLUG_PATTERN = /^[-a-zA-Z0-9_]+$/;

export const isValidSlug = (value: string) => {
  return SLUG_PATTERN.test(value);
};
